const light = {
    isDark: false,
    background: "#000",
    colors: "#fff",
}

export default light